export const SET_DEVELOPMENT_TAB = 'SET_DEVELOPMENT_TAB'
export const SET_BLOG_CATEGORIES = 'SET_BLOG_CATEGORIES'
export const SET_TOP_ARTICLES = 'SET_TOP_ARTICLES'
export const SET_BLOGS = 'SET_BLOGS'
export const SET_BLOG_DETAIL = 'SET_BLOG_DETAIL'
